import type { PropsWithChildren } from "react";

export function PageCenter({ children }: PropsWithChildren) {
  return <div className={"absolute inset-0 flex items-center justify-center"}>{children}</div>;
}
